import { z } from 'zod'
import dayjs, { Dayjs } from 'dayjs'

export const UploadResultSchema = z.object({
  uploadedDate: z.custom<Dayjs>(
    (val) => dayjs(val).isValid(),
    'Please select a valid date'
  ),
})
